import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Card, CircularProgress } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import MDSnackbar from "components/MDSnackbar"

// Custom component
import PackageInformation from "./PackageInformation"
// Service
import * as packageService from "../../../services/packages/package.service"

function PackageDetails() {
  const { packageId } = useParams()
  const [packageObject, setPackageObject] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [snackbarObject, setSnackbarObject] = useState({
    open: false,
    title: "",
    content: "",
    color: "primary",
    icon: "",
  })

  // Handle open snackbar
  const handleOpenSnackbar = (status, title, content, icon) => {
    setSnackbarObject({
      ...snackbarObject,
      title,
      open: true,
      content,
      color: status,
      icon,
    })
  }

  // Handle close snackbar
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    setSnackbarObject({
      ...snackbarObject,
      open: false,
    })
  }

  // Get package information
  const getPackageDetails = async () => {
    setIsLoading(true)
    try {
      const { data } = await packageService.findOnePackage(packageId)
      setIsLoading(false)
      const pkg = { ...data[0] }
      const items = data.items || []
      if (pkg.unitPrice == null && items.length === 1) {
        pkg.unitPrice = items[0].unitPrice
      }
      pkg.hasMultipleItems = items.length > 1
      if (items.length > 0) {
        pkg.productQuantity = items.reduce((sum, item) => sum + (item.quantity || 0), 0)
      }
      setPackageObject(pkg)
    } catch (error) {
      handleOpenSnackbar("error", "Package Details", "Something wrong, try again", "error")
      setIsLoading(true)
    }
  }

  useEffect(() => {
    getPackageDetails()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isLoading ? (
    <MDBox
      mt={8}
      sx={{
        height: "80vh",
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress color="secondary" />
    </MDBox>
  ) : (
    <>
      <DashboardLayout>
        <DashboardNavbar absolute isMini />
        <MDBox mt={8}>
          <MDBox mb={3}>
            <Card id="package-details">
              <MDBox pt={3} px={2}>
                <MDTypography variant="h6" fontWeight="medium">
                  Package Information
                </MDTypography>
              </MDBox>
              <MDBox pt={1} pb={2} px={2}>
                <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                  <PackageInformation details={packageObject || {}} />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <MDSnackbar
        color={snackbarObject.color}
        icon={snackbarObject.icon}
        title={snackbarObject.title}
        content={snackbarObject.content}
        open={snackbarObject.open}
        close={handleCloseSnackbar}
        dateTime=""
      />
    </>
  )
}

export default PackageDetails
